import { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronDown, Loader2, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { useAppVersion } from '../version';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NoteList = ({ items }) => (
  <ul className="space-y-2 text-sm text-slate-700">
    {items.map((t, i) => (
      <li key={i} className="flex gap-2"><span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-orange-500" />{t}</li>
    ))}
  </ul>
);

export const ReleaseNotesDialog = ({ open, onOpenChange }) => {
  const { version: APP_VERSION } = useAppVersion();
  const [notes, setNotes] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!open || notes) return;
    setError('');
    axios.get(`${API}/release-notes`).then(r => setNotes(r.data)).catch(e => setError(e.response?.data?.detail || 'Sürüm notları yüklenemedi'));
  }, [open, notes]);
  const current = notes?.find(n => n.version === APP_VERSION) || notes?.[0];
  const older = notes?.filter(n => n !== current) || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="release-notes-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-orange-500" /> Sürüm Notları — {APP_VERSION}</DialogTitle>
          <DialogDescription>{current?.date ? `Yayın tarihi: ${current.date.split('-').reverse().join('.')}` : 'Bu sürümdeki değişiklikler'}</DialogDescription>
        </DialogHeader>
        {error && <p className="text-sm text-red-600" data-testid="release-notes-error">{error}</p>}
        {!notes && !error && <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" />}
        {current && <div data-testid="release-notes-current"><NoteList items={current.items} /></div>}
        {older.length > 0 && (
          <div className="mt-2 space-y-2 border-t pt-3" data-testid="release-notes-older">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Önceki sürümler</p>
            {older.map(n => (
              <details key={n.version} className="group rounded-lg border px-3 py-2" data-testid={`release-notes-${n.version}`}>
                <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold text-slate-800">
                  {n.version} <span className="flex items-center gap-1 text-xs font-normal text-slate-500">{n.date?.split('-').reverse().join('.')}<ChevronDown className="h-4 w-4 transition-transform group-open:rotate-180" /></span>
                </summary>
                <div className="pt-2"><NoteList items={n.items} /></div>
              </details>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
